"use client";

import { Typography } from "@/components/ui/typography";
import { PeopleCountInput } from "../home/PeopleCountInput";
import { AccommodationPrices } from "./AccommodationPrices";
import DateRangePicker from "../ui/date-range-picker";
import { usePdpStayDates } from "@/hooks/usePdpStayDates";
import { usePdpPriceCalendar } from "@/lib/react-query/queries/accommodation/use-pdp-price-calendar";

export function AccommodationBooking({
  accommodationId,
  stateCity,
  slug,
}: {
  accommodationId: string;
  stateCity: string;
  slug: string;
}) {
  const { dateRange, setStayDates, capacity, setCapacity } = usePdpStayDates();
  const { availableDates, isAvailabilityPending } = usePdpPriceCalendar({
    accommodationId,
    capacity,
  });

  return (
    <div className="rounded-xl border border-gray-100 p-5 space-y-4">
      <div className="flex gap-3">
        <DateRangePicker
          className="border rounded-lg border-gray-100 flex-1"
          dateRange={dateRange}
          onSelect={setStayDates}
          availableDates={availableDates}
          isAvailabilityPending={isAvailabilityPending}
          constrainAvailability
        />
        <PeopleCountInput
          value={capacity}
          onChange={setCapacity}
          className="border rounded-lg border-gray-100 flex items-center gap-1 p-3.5"
        />
      </div>
      <hr />
      <Typography variant="bodySRegular" color="gray600">
        براساس حداکثر نفرات پایه
      </Typography>
      <AccommodationPrices
        accommodationId={accommodationId}
        stateCity={stateCity}
        slug={slug}
      />
    </div>
  );
}
